import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FeedbackRibbon, FeedbackDialogParams, FeedbackCategory } from 'owa-feedback';
import {
    collabSpaceFeedbackRibbonMessage,
    collabSpaceFeedbackDialogTitle,
    collabSpaceFeedbackDialogSubTitle,
    collabSpaceFeedbackThankYouMessage,
    collabSpaceFeedbackDialogPlaceholder,
    collabSpaceFeedbackYesButtonText,
    collabSpaceFeedbackNoButtonText,
    collabSpaceFeedbackOption1,
    collabSpaceFeedbackOption2,
    collabSpaceFeedbackOption3,
    collabSpaceFeedbackOption4,
} from './CollabSpaceInlineFeedback.locstring.json';
import loc from 'owa-localize';
import { getViewStateById } from '../selectors/collabSpaceSelectors';

const styles = require('./CollabSpaceInlineFeedback.scss');

export interface CollabSpaceInlineFeedbackProps {
    viewStateId: string;
}

export default observer(function CollabSpaceInlineFeedback(props: CollabSpaceInlineFeedbackProps) {
    const viewState = getViewStateById(props.viewStateId);
    if (!viewState) {
        return null;
    }
    const { isCollabSpaceExplicitlyDisabled } = viewState;

    const feedbackCategories: FeedbackCategory[] = [
        {
            logString: 'Not relevant',
            uiString: loc(collabSpaceFeedbackOption1),
        },
        {
            logString: "Didn't want others editing",
            uiString: loc(collabSpaceFeedbackOption2),
        },
        {
            logString: 'Not sure how this feature works',
            uiString: loc(collabSpaceFeedbackOption3),
        },
        {
            logString: 'Other',
            uiString: loc(collabSpaceFeedbackOption4),
        },
    ];

    const feedbackDialogParams: FeedbackDialogParams = {
        title: loc(collabSpaceFeedbackDialogTitle),
        subTitle: loc(collabSpaceFeedbackDialogSubTitle),
        categories: feedbackCategories,
        ghostText: loc(collabSpaceFeedbackDialogPlaceholder),
        createUVTicket: false,
        invokeFeedbackDialog: true,
    };

    return (
        isCollabSpaceExplicitlyDisabled && (
            <div className={styles.feedbackContainer}>
                <FeedbackRibbon
                    ribbonMessageClassName={styles.ribbonMessage}
                    feature="CollabSpace"
                    subFeature="Create/Edit"
                    ribbonMessage={loc(collabSpaceFeedbackRibbonMessage)}
                    yesButtonText={loc(collabSpaceFeedbackYesButtonText)}
                    noButtonText={loc(collabSpaceFeedbackNoButtonText)}
                    thankYouMessage={loc(collabSpaceFeedbackThankYouMessage)}
                    yesFeedbackDialogParams={feedbackDialogParams}
                />
            </div>
        )
    );
});
